module.exports = __webpack_public_path__ + "static/media/int-bg-6.23a1caae.jpg";